import RegualmentoContainer from './midia.container'

export default RegualmentoContainer
